// maths.portll.net — the grown-up gate (also the iPad parental gate, App Store 1.3).
//
// A deliberate "are you a grown-up?" step in front of the Grown-Ups' Corner. The gate
// IS the numeric PinPad, verified server-side by verifyParentGate → verifyParentPin.
// If no parent PIN has been set yet, verifyParentPin returns { ok:true, noPin:true } —
// so any 4-digit entry passes (still an intentional gate) and we nudge toward setting a
// PIN in Settings. This is a UX/child-safety gate, never a security boundary.

import { useState } from "react";
import { useProfiles } from "../contexts/ProfileContext.jsx";
import { PageHeader, Card, Button, Note, injectStyles } from "../components/ui.jsx";
import PinPad from "../components/PinPad.jsx";

export default function ParentGate() {
  const { verifyParentGate, activeChild, displayNameFor } = useProfiles();
  const [unlocked, setUnlocked] = useState(false);
  const [noPin, setNoPin] = useState(false);

  const header = (
    <PageHeader
      title="Grown-Ups' Corner"
      subtitle="Home practice and evidence — not a formal assessment."
      back="/app"
    />
  );

  if (!unlocked) {
    return (
      <main className="container">
        {header}
        <Card className="pg-gate">
          <PinPad
            title="Ask a grown-up"
            subtitle="Enter the grown-up PIN to continue."
            verify={verifyParentGate}
            onSuccess={(res) => {
              setNoPin(!!res.noPin);
              setUnlocked(true);
            }}
          />
        </Card>
        <p className="pg-tip">
          This area is for parents and carers — planning Home Missions and keeping a private record of
          what you've explored together.
        </p>
      </main>
    );
  }

  return (
    <main className="container">
      {header}
      {noPin && (
        <Note tone="sky">
          Tip: you can set a grown-up PIN in Settings to make this gate stronger.
        </Note>
      )}
      <div className="pg-links">
        <Button to="/grown-ups/children" size="lg">
          Choose a child
        </Button>
        {activeChild && (
          <Button to={`/grown-ups/child/${activeChild.id}`} size="lg" variant="secondary">
            Continue with {displayNameFor(activeChild) || "this child"}
          </Button>
        )}
        <Button to="/grown-ups/settings" size="lg" variant="secondary">
          Settings
        </Button>
      </div>
    </main>
  );
}

injectStyles(
  "maths-parentgate-styles",
  `
.pg-gate{padding:1.5rem 1.25rem;}
.pg-tip{color:var(--ink-soft);max-width:38ch;margin:1rem auto 0;text-align:center;}
.pg-links{display:grid;gap:.75rem;max-width:24rem;margin:0 auto;}
.pg-links .ui-btn{width:100%;}
`
);
